module.exports = __webpack_public_path__ + "media/images/sort_arrow_down-65c6a74d7a54c9fd33c1cdce59ea142f.png";